import styled from "styled-components";

export const Container = styled.div`
  font-family: "Pretendard";
  font-size: 18px;
  min-height: calc(100vh - 400px);
  h3 {
    font-size: 36px;
    font-weight: 800;
    margin: 50px 0;
    &.max {
      max-width: 1440px;
      margin: 50px auto;
      padding: 0 20px;
    }
  }
  .pagination {
    margin-top: 50px;
  }
  .count {
    display: flex;
    align-items: center;
    color: #666;
    margin: 50px 0;
    strong {
      margin-left: 5px;
    }
    svg {
      margin-right: 10px;
    }
  }
  button {
    border: none;
  }
  .buttons {
    display: flex;
    justify-content: center;
    margin: 50px 0;
    gap: 20px;
    &.end {
      justify-content: flex-end;
    }
  }
  &.theme-0 {
    button,
    input,
    select {
      font-family: "Pretendard";
    }
    h3 {
      position: relative;
      span {
        text-transform: uppercase;
        background: #fff;
        padding: 0 20px 0 27px;
      }
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        width: 7px;
        height: 70%;
        background-color: #000;
        transform: translateY(-50%);
      }
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        display: block;
        width: 100%;
        height: 1px;
        background-color: #ddd;
        z-index: -1;
      }
      &.max::after {
        width: calc(100% - 40px);
      }
    }
    .count strong {
      color: #e9463f;
    }
    .buttons {
      gap: 0;
      button {
        font-size: 18px;
        width: 200px;
        height: 50px;
        border: 1px solid #d8d8d8;
        background: transparent;
        color: #000;
        &:first-child {
          border-color: #000;
          background: #000;
          color: #fff;
        }
      }
    }
  }
  &.theme-2 {
    button,
    input,
    select {
      font-family: "Pretendard";
    }
    h3 {
      color: #222;
      font-family: "Pretendard";
      text-align: center;
      &.max {
        max-width: 1240px;
      }
    }
    .pagination {
      gap: 10px;
      li {
        width: 34px;
        height: 34px;
        border: 1px solid #888888;
        border-radius: 2px;
        &.active,
        &:hover {
          background: #000;
          color: #fff;
        }
        a {
          font-size: 16px;
        }
      }
    }
    .count {
      color: rgba(0, 0, 0, 0.5);
    }
    .buttons {
      gap: 10px;
      button {
        font-size: 16px;
        width: 100px;
        height: 38px;
        background: transparent;
        border: 1px solid #9f9f9f;
        border-radius: 5px;
        font-weight: 500;
        color: #9f9f9f;
        &:first-child {
          background: #15181e;
          border-color: #15181e;
          color: #fff;
        }
      }
    }
  }
  &.theme-4 {
    button,
    input,
    select {
      font-family: "Pretendard";
    }
    h3 {
      text-transform: uppercase;
      text-align: center;
      span {
        font-size: larger;
      }
    }
    .pagination {
      li {
        border: none;
        a {
          color: #999;
        }
      }
      li.active,
      li:hover {
        background: transparent;
        a {
          color: #333;
        }
      }
    }
    .count {
      color: #999;
      strong {
        color: #3b8ef6;
      }
    }
    .buttons {
      gap: 10px;
      button {
        width: 200px;
        height: 50px;
        color: #000;
        background: transparent;
        border-radius: 5px;
        border: 1px solid #000;
        &:first-child {
          background: #000;
          color: #fff;
        }
      }
    }
  }
  @media screen and (max-width: 1050px) {
    font-size: 16px;
    h3 {
      font-size: 32px;
    }
    &.theme-0 {
      h3 span {
        padding: 0 15px 0 22px;
      }
      .buttons button {
        font-size: 16px;
        width: 150px;
        height: 40px;
      }
    }
    &.theme-2 {
      .count {
        margin: 30px 0;
      }
      .buttons button {
        font-size: 14px;
      }
    }
    &.theme-4 {
      .buttons button {
        width: 150px;
        font-size: 14px;
      }
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 12px;
    min-height: 100vh;
    h3 {
      font-size: 26px;
    }
    &.theme-0 {
      h3 span {
        padding: 0 10px 0 17px;
      }
    }
    &.theme-0 {
      h3 span {
        padding: 0 15px 0 22px;
      }
      .buttons button {
        font-size: 14px;
        width: 120px;
        height: 40px;
      }
    }
    &.theme-2 {
      .buttons button {
        font-size: 12px;
      }
    }
    &.theme-4 {
      .buttons button {
        width: 100px;
        height: 40px;
        font-size: 12px;
      }
    }
  }
`;

export const TabMenuContainer = styled.ul`
  max-width: 1440px;
  padding: 0 20px;
  width: 100%;
  display: flex;
  margin: 50px auto;
  align-items: center;
  justify-content: center;
  li {
    height: 50px;
    line-height: 50px;
    text-align: center;
    width: calc(100% / 3);
    background: #fbfbfc;
    border: 1px solid #d8d8d8;
    cursor: pointer;
    transition: 0.3s;
    border-right: none;
    color: #777777;
    &:last-child {
      border-right: 1px solid #d8d8d8;
    }
    &.active {
      color: #000;
      font-weight: 700;
    }
  }
  &.theme-2 {
    gap: 10px;
    max-width: 1000px;
    li {
      max-width: 200px;
      width: calc((100% - 20) / 3);
      background: transparent;
      border: 1px solid #dedede;
      border-radius: 25px;
      font-weight: 500;
      color: #9a9a9a;
      &.active {
        background: #f9f8f6;
        border-color: #f9f8f6;
        color: #222;
      }
    }
  }
  &.theme-4 {
    gap: 5px;
    li {
      color: #000;
      background: transparent;
      border-radius: 5px;
      border: 1px solid #000;
      &.active {
        font-weight: normal;
        background: #000;
        color: #fff;
      }
    }
  }
  @media screen and (max-width: 767px) {
    &.theme-2 {
      justify-content: flex-start;
      li {
        height: 35px;
        line-height: 35px;
      }
    }
    &.theme-4 {
      li {
        font-size: 13px;
        line-height: 40px;
        height: 40px;
      }
    }
  }
`;

export const QuickMenuContainer = styled.div`
  position: fixed;
  right: 0;
  top: 50vh;
  z-index: 10;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  button {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #000;
    color: #fff;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px;
    margin-right: 20px;
    border: none;
    &.active {
      transform: scaleX(-1);
    }
    svg {
      margin: 0;
    }
  }
  ul {
    &.active {
      width: 100px;

      opacity: 1;
    }
    &.inactive {
      width: 10px;
    }
    overflow: hidden;
    border-radius: 20px 0 0 20px;
    padding: 20px 0;
    background: #fff;
    transition: 0.3s;
    font-size: 13px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    li {
      width: 100px;
      text-align: center;
      margin-bottom: 25px;
      cursor: pointer;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        width: 44px;
        height: 44px;
        object-fit: contain;
        margin-bottom: 7px;
      }
      span {
        display: block;
        color: #535353;
      }
    }
  }
  @media screen and (max-width: 1050px) {
    position: fixed;
    button {
      margin: 10px;
      width: 40px;
      height: 40px;
    }
    ul {
      &.active {
        width: 90px;
      }
      li {
        width: 90px;
        img {
          width: 40px;
          height: 40px;
        }
        span {
          font-size: 12px;
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    button {
      margin: 5px;
      width: 35px;
      height: 35px;
    }
    ul {
      &.active {
        width: 80px;
      }
      li {
        width: 80px;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
`;

export const ScrollTopBtn = styled.button`
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  border: none;
  svg {
    margin: 0;
  }
  &.theme-0 {
    background-color: #efefef;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    font-size: 30px;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  }
  &.theme-2 {
    background: #000;
    color: #fff;
    width: 50px;
    height: 50px;
    font-size: 28px;
    border-radius: 50%;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    &:hover {
      font-size: 36px;
    }
  }
  &.theme-4 {
    border-radius: 50%;
    background: #333;
    color: #fff;
    width: 50px;
    height: 50px;
    font-size: 35px;
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    &:hover {
      background: #000;
    }
    svg {
      stroke-width: 1;
    }
  }
  @media screen and (max-width: 767px) {
    bottom: 6rem;
  }
`;
